import { FC, ReactNode } from 'react';
import { MenuItem as MUIMenuItem, MenuItemProps } from '@mui/material';

export type AppMenuItemProps = MenuItemProps & {
  children?: ReactNode;
};

export const MenuItem: FC<AppMenuItemProps> = ({ children, ...props }) => {
  return <MUIMenuItem {...props}>{children}</MUIMenuItem>;
};
